/**
 * Add product (add-on) to tenant subscription using Once V2 API
 * This replaces the Mushodo AddProduct call
 */
import { post } from './once-v2-api';
import { useOnceStore } from '@apps-once/store';

export type AddProductRequest = {
  tenantId?: string; // Optional: if not provided, will get from Once store
  addOnProductIdentifier: string;
  isTrial: boolean;
  promoCode?: string;
};

export type AddProductResponse = {
  success: boolean;
  error?: string;
};

/**
 * Add a product (add-on) to a tenant's subscription
 * Replaces the Mushodo AddProduct call with Once V2 API
 *
 * @param {AddProductRequest} request - The add product request parameters
 * @return {Promise<AddProductResponse>} - The response indicating success
 */
export async function addProduct(
  request: AddProductRequest
): Promise<AddProductResponse> {
  // Get tenant ID from request or Once store
  const onceStore = useOnceStore();
  const tenantId = request.tenantId || onceStore.id;

  if (!tenantId) {
    throw new Error(
      'Tenant ID is required. Either provide it in the request or ensure Once store has the current business selected.'
    );
  }

  const response = await post<any>(
    '/once/v2/tenants/subscription/product/add-on',
    {
      data: {
        tenantId,
        productIdentifier: request.addOnProductIdentifier,
        isTrial: request.isTrial,
        promoCode: request.promoCode || '',
      },
    }
  );

  const responseData: AddProductResponse = response.data;

  if (!responseData || !responseData.success) {
    throw new Error(responseData?.error || 'Failed to add product');
  }

  return responseData;
}
